import backendUrl from "./backendUrl";
import { imagebaseUrl } from "./config";
function ImageConverter(Images) {
  const imagePaths = Images.split(',').map(path => `${imagebaseUrl}/${path.replace(/\\/g, '/')}`);

  return imagePaths;
}

export default ImageConverter;